import type { HotelResultsFilterValue } from './hotel_results_filters.js';

/** Os fatos de política de uma oferta, para o corte "Dentro da política". */
export type HotelPolicyFacts = {
  /** O quarto MAIS BARATO do hotel está dentro da política. */
  withinPolicy: boolean;
  /** A tarifa mais barata COM café / reembolsável / café+reembolsável está
   *  dentro da política (#5820). `undefined` = o fornecedor não disse. */
  breakfastRateWithinPolicy?: boolean;
  refundableRateWithinPolicy?: boolean;
  breakfastRefundableRateWithinPolicy?: boolean;
  /** O hotel tem UMA tarifa com café E reembolso (#5849). `undefined` =
   *  desconhecido. */
  hasBreakfastRefundable?: boolean;
};

/** Eixo da política: com o corte ligado, só quem está DENTRO passa. Com café
 *  e/ou reembolso também ligados, "dentro" é da TARIFA com esses atributos
 *  (#5820) — `withinPolicy` é do quarto mais barato, e o acordo sem café dentro
 *  do teto aprovava hotel cujas tarifas com café estavam todas fora. Sem o fato
 *  da tarifa, vale `withinPolicy`, como antes (dado ausente não esvazia a
 *  lista). Um eixo de tarifa ignorado na contagem sai também da conta conjunta.
 *  Espelho de `isWithinPolicy` do predicado irmão (genui-kit
 *  `hotel_planner_directives.ts`). Fora de `hotel_results_filters.tsx` pelo teto
 *  de linhas daquele arquivo. */
export function matchesPolicy(
  facts: HotelPolicyFacts,
  filters: Pick<HotelResultsFilterValue, 'policyOnly' | 'breakfastOnly' | 'refundableOnly'>,
  ignoredAxis?: keyof HotelResultsFilterValue,
): boolean {
  if (ignoredAxis === 'policyOnly' || !filters.policyOnly) return true;
  const breakfast = filters.breakfastOnly && ignoredAxis !== 'breakfastOnly';
  const refundable = filters.refundableOnly && ignoredAxis !== 'refundableOnly';
  return rateWithinPolicy(facts, breakfast, refundable) ?? facts.withinPolicy;
}

function rateWithinPolicy(
  facts: HotelPolicyFacts,
  breakfast: boolean,
  refundable: boolean,
): boolean | undefined {
  // #5849: sem UMA tarifa com café E reembolso, nenhuma está dentro.
  if (breakfast && refundable)
    return facts.hasBreakfastRefundable === false
      ? false
      : facts.breakfastRefundableRateWithinPolicy;
  if (breakfast) return facts.breakfastRateWithinPolicy;
  if (refundable) return facts.refundableRateWithinPolicy;
  return undefined;
}
